import(/* webpackMode: "eager" */ "/codebuild/output/src3892242465/src/pixelated-tech/apps/informationfocus/src/app/(pages)/(home)/page.tsx");
